import { Location } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { BussinessDocumentsClassEnums } from 'src/app/enum/bussiness-documets-class-enums';
import { BussinessDocumentsTypeModel } from 'src/app/models/management/bussiness-documents-type.models';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { BussinessDocumentsTypeService } from 'src/app/services/management/bussiness-documents-type.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-register-bussiness-documents-type',
  templateUrl: './register-bussiness-documents-type.component.html',
  styleUrls: ['./register-bussiness-documents-type.component.scss'],
  standalone: false
})
export class RegisterBussinessDocumentsTypeComponent implements OnInit {

  branchId: number = 0;
  bussinessDocumentsClassId: number = 0;
  bussinessDocumentsTypeContract: BussinessDocumentsTypeModel = new BussinessDocumentsTypeModel();
  bussinessDocumentsTypeId: number = 0;
  disabledForm: boolean = false;
  enterpriseId: number = 0;
  formBussinessDocumentsType: FormGroup = new FormGroup({});
  isOpened: string | undefined = undefined;
  listBranches: any[] = [];
  listBusinessDianTypes: any[] = [];
  listBussinessClasss: any[] = [];
  listEnterprises: any[] = [];
  nameWindow: string = 'Captura Tipos de Documentos Comerciales';
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  severityState: string = 'success';
  stateBussinessDocumentsType: string = '';
  titleState: string = '';
  url: string = 'bussiness-documents-type';

  constructor(private confirmDialogService: ConfirmDialogService,
    private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private bussinessDocumentsTypeService: BussinessDocumentsTypeService,
    private enterpriseService: EnterpriseService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private headerService: HeaderService,
    private location: Location,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private windowService: WindowService) {
    this.validateForm(new BussinessDocumentsTypeModel());
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.bussinessDocumentsTypeId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async changeBranch(branchId: number, loadAll: boolean) {
    this.branchId = branchId;
    await this.getFirstEnterpriseByBranch(branchId);
    if (loadAll) {
      await this.getAllLists();
    } else {
      await this.getAllLists('enterprises');
      this.resetContract(this.bussinessDocumentsClassId, branchId, this.enterpriseId);
    }
  }

  changeBussinessDocumentsClass(bussinessDocumentsClassId: number) {
    this.bussinessDocumentsClassId = bussinessDocumentsClassId;
    this.resetContract(bussinessDocumentsClassId, this.branchId, this.enterpriseId);
  }

  async changeCode(code: number) {
    this.bussinessDocumentsClassId = this.formBussinessDocumentsType.get("bussinessDocumentsClassId")?.value;
    this.branchId = this.formBussinessDocumentsType.get("branchId")?.value;
    this.enterpriseId = this.formBussinessDocumentsType.get("enterpriseId")?.value;
    if (!this.bussinessDocumentsClassId) {
      return this.toastHandlerService.showToast('warning', 'Seleccione una clase.');
    }
    if (!this.branchId) {
      return this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.');
    }
    if (!this.enterpriseId) {
      return this.toastHandlerService.showToast('warning', 'Seleccione una empresa.');
    }
    if (!code) {
      this.resetContract(this.bussinessDocumentsClassId, this.branchId, this.enterpriseId);
      return;
    }
    try {
      const response = await firstValueFrom(this.bussinessDocumentsTypeService.getBussinessDocumentsTypeByKeys(this.bussinessDocumentsClassId,
        this.branchId, this.enterpriseId, code));
      this.bussinessDocumentsTypeId = response.bussinessDocumentsTypeId;
      this.bussinessDocumentsTypeContract = response;
      this.validateForm(this.bussinessDocumentsTypeContract);
      this.location.replaceState(`/${this.url}/register/${this.bussinessDocumentsTypeId}`);
    } catch (error) {
      this.resetContract(this.bussinessDocumentsClassId, this.branchId, this.enterpriseId);
      console.error('Error al buscar el tipo de documento comercial.', error);
    }
  }

  changeEnterprise(enterpriseId: number) {
    this.enterpriseId = enterpriseId;
    this.resetContract(this.bussinessDocumentsClassId, this.branchId, enterpriseId);
  }

  async changeStateBussinessDocumentsType() {
    const { bussinessDocumentsTypeId } = this.bussinessDocumentsTypeContract;
    if (!bussinessDocumentsTypeId) {
      this.toastHandlerService.showToast('warning', 'Debe crear un tipo de documento comercial.');
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `No tiene permisos para cambiar el estado del tipo de documento comercial.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    try {
      const response = await firstValueFrom(this.bussinessDocumentsTypeService.setActiveBussinessDocumentsType(bussinessDocumentsTypeId));
      this.bussinessDocumentsTypeContract = response;
      this.validateForm(this.bussinessDocumentsTypeContract);
      const successMessage = response.active ? 'El tipo de documento comercial fue activado exitosamente.'
        : 'El tipo de documento comercial fue inactivado exitosamente.';
      this.toastHandlerService.showToast('success', successMessage);
    } catch (error) {
      console.error('Error al cambiar el estado del tipo de documento comercial.', error);
    }
  }

  async createNewRegister() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para crear tipos de documentos comerciales.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    this.resetContract(this.bussinessDocumentsClassId, this.branchId, this.enterpriseId);
  }

  async delete() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `El usuario no tiene permisos para eliminar el tipo de documento comercial.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    if (!this.bussinessDocumentsTypeId) {
      this.toastHandlerService.showToast('warning', 'Debe crear un tipo de documento comercial.');
      return;
    }
    if (await this.confirmDialogService.confirm('¿Realmente desea eliminar el tipo de documento comercial?')) {
      try {
        await firstValueFrom(this.bussinessDocumentsTypeService.deleteBussinessDocumentsType(this.bussinessDocumentsTypeId));
        this.createNewRegister();
        this.toastHandlerService.showToast('success', 'El tipo de documento comercial fue eliminado exitosamente.');
      } catch (error) {
        console.error('Error al eliminar el tipo de documento comercial.', error);
      }
    }
  }

  async getAllLists(listToLoad?: | 'branches' | 'enterprises' | 'businessDianTypes' | 'bussinessClasss') {
    try {
      const loaders = {
        branches: async () =>
          this.listBranches = await firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        enterprises: async () =>
          this.listEnterprises = await firstValueFrom(this.enterpriseService.getEnterprisesByBranchIdForSelect(this.branchId)),
        businessDianTypes: async () =>
          this.listBusinessDianTypes = await firstValueFrom(this.bussinessDocumentsTypeService.getAllBussinessDocumentsDianTypesForSelect()),
        bussinessClasss: async () =>
          this.listBussinessClasss = await firstValueFrom(this.bussinessDocumentsTypeService.getAllBussinessDocumentsClasssForSelect()),
      };
      if (listToLoad) {
        await loaders[listToLoad]();
      } else {
        await Promise.all([
          loaders.branches(),
          loaders.enterprises(),
          loaders.businessDianTypes(),
          loaders.bussinessClasss(),
        ]);
      }
    } catch (error) {
      console.error('Error obtener las listas.', error);
    }
  }

  async getButtonClick(buttonClick: any) {
    this.bussinessDocumentsClassId = this.formBussinessDocumentsType.get("bussinessDocumentsClassId")?.value;
    this.branchId = this.formBussinessDocumentsType.get("branchId")?.value;
    this.enterpriseId = this.formBussinessDocumentsType.get("enterpriseId")?.value;
    if (!this.bussinessDocumentsClassId) {
      return this.toastHandlerService.showToast('warning', 'Seleccione una clase.');
    }
    if (!this.branchId) {
      return this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.');
    }
    if (!this.enterpriseId) {
      return this.toastHandlerService.showToast('warning', 'Seleccione una empresa.');
    }
    await this.handleBussinessDocumentsTypeNavigation(buttonClick, this.bussinessDocumentsClassId, this.branchId, this.enterpriseId)
  }

  async getBussinessDocumentsTypeById() {
    try {
      const response = await firstValueFrom(this.bussinessDocumentsTypeService.getBussinessDocumentsTypeById(this.bussinessDocumentsTypeId));
      this.bussinessDocumentsClassId = response.bussinessDocumentsClassId;
      this.enterpriseId = response.enterpriseId;
      this.bussinessDocumentsTypeContract = response;
      const branchChanged = this.branchId != response.branchId;
      if (branchChanged) {
        await this.changeBranch(response.branchId, true);
      }
      this.validateForm(this.bussinessDocumentsTypeContract);
    } catch (error) {
      console.error('Error al obtener el tipo de documento comercial.', error);
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      if (!response.branchId) {
        this.branchId = 0;
        return;
      }
      this.branchId = response.branchId;
      this.bussinessDocumentsClassId = BussinessDocumentsClassEnums.factura;
      await Promise.all([
        this.getAllLists(),
        this.getFirstEnterpriseByBranch(response.branchId)
      ]);
    } catch (error) {
      this.branchId = 0;
      console.error('Error al obtener la sucursal del usuario.', error);
    }
  }

  async getFirstEnterpriseByBranch(branchId: number) {
    try {
      const response = await firstValueFrom(this.enterpriseService.getFirstEnterpriseByBranch(branchId));
      if (!response) {
        this.enterpriseId = 0;
        this.toastHandlerService.showToast('error', 'La Sucursal no tiene Empresas creadas.');
        return;
      };
      this.enterpriseId = response.enterpriseId;
    } catch (error) {
      console.error('Error al obtener la primera empresa por sucursal.', error);
    }
  }

  async getPermission() {
    await this.getPermissionProfileByUrl();
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('error', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`);
      }
    } else {
      localStorage.clear();
    }
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async handleInitialState() {
    if (this.bussinessDocumentsTypeId) {
      await this.getBussinessDocumentsTypeById();
    } else {
      await this.getFirstBranchByUserAuthenticatedAsync();
      this.createNewRegister();
    }
  }

  async handleBussinessDocumentsTypeNavigation(buttonClick: any, bussinessDocumentsClassId: number, branchId: number, enterpriseId: number) {
    const code = this.formBussinessDocumentsType.get("code")?.value;
    const actionMap: Record<string, () => Promise<BussinessDocumentsTypeModel>> = {
      first: () =>
        firstValueFrom(this.bussinessDocumentsTypeService.getFirstBussinessDocumentsTypeByKeys(bussinessDocumentsClassId, branchId,
          enterpriseId)),
      previus: () =>
        firstValueFrom(this.bussinessDocumentsTypeService.getPreviusBussinessDocumentsTypeByKeys(bussinessDocumentsClassId, branchId,
          enterpriseId, code)),
      next: () =>
        firstValueFrom(this.bussinessDocumentsTypeService.getNextBussinessDocumentsTypeByKeys(bussinessDocumentsClassId, branchId,
          enterpriseId, code)),
      last: () =>
        firstValueFrom(this.bussinessDocumentsTypeService.getLastBussinessDocumentsTypeByKeys(bussinessDocumentsClassId, branchId,
          enterpriseId)),
    };
    const action = actionMap[buttonClick.target.id];
    if (!action) {
      this.resetContract(this.bussinessDocumentsClassId, this.branchId, this.enterpriseId);
      return;
    }
    try {
      const bussinessDocumentsType = await action();
      this.bussinessDocumentsTypeId = bussinessDocumentsType.bussinessDocumentsTypeId;
      this.bussinessDocumentsTypeContract = bussinessDocumentsType;
      this.validateForm(this.bussinessDocumentsTypeContract);
      this.location.replaceState(`/${this.url}/register/${this.bussinessDocumentsTypeId}`);
    } catch (error) {
      console.error(`Error al buscar el tipo de documento comercial (${buttonClick.target.id}).`, error);
    }
  }

  async send() {
    this.validateFormControls();
    if (this.formBussinessDocumentsType.valid) {
      const modelBussinessDocumentsType = this.formBussinessDocumentsType.getRawValue() as BussinessDocumentsTypeModel;
      if (this.bussinessDocumentsTypeId == 0) {
        try {
          const response = await firstValueFrom(this.bussinessDocumentsTypeService.createBussinessDocumentsType(modelBussinessDocumentsType));
          this.bussinessDocumentsTypeId = response.bussinessDocumentsTypeId;
          this.bussinessDocumentsTypeContract = response;
          this.validateForm(this.bussinessDocumentsTypeContract);
          this.location.replaceState(`/${this.url}/register/${this.bussinessDocumentsTypeId}`);
          this.toastHandlerService.showToast('success', `El tipo de documento comercial fue creado exitosamente.`);
        } catch (error) {
          console.error('Error al crear el tipo de documento comercial.', error);
        }
      } else {
        this.bussinessDocumentsTypeContract.alterCode = modelBussinessDocumentsType.alterCode;
        this.bussinessDocumentsTypeContract.description = modelBussinessDocumentsType.description;
        this.bussinessDocumentsTypeContract.isRental = modelBussinessDocumentsType.isRental;
        this.bussinessDocumentsTypeContract.bussinessDocumentsDianTypeId = modelBussinessDocumentsType.bussinessDocumentsDianTypeId;
        this.bussinessDocumentsTypeContract.cxcInvoiceConcept = modelBussinessDocumentsType.cxcInvoiceConcept;
        this.bussinessDocumentsTypeContract.cxcCreditNoteConcept = modelBussinessDocumentsType.cxcCreditNoteConcept;
        this.bussinessDocumentsTypeContract.cxcDebitNoteConcept = modelBussinessDocumentsType.cxcDebitNoteConcept;
        try {
          const response = await firstValueFrom(this.bussinessDocumentsTypeService.updateBussinessDocumentsType(this.bussinessDocumentsTypeContract));
          this.bussinessDocumentsTypeContract = response;
          this.validateForm(this.bussinessDocumentsTypeContract);
          this.toastHandlerService.showToast('success', `El tipo de documento comercial fue modificado exitosamente.`);
        } catch (error) {
          console.error('Error al modificar el tipo de documento comercial.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      bussinessDocumentsClassId: {
        required: 'Debe seleccionar una Clase de Documento.',
        min: 'Debe seleccionar una Clase de Documento válida.'
      },
      branchId: {
        required: 'Debe seleccionar una Sucursal.'
      },
      enterpriseId: {
        required: 'Debe seleccionar una Empresa.'
      },
      alterCode: {
        maxlength: 'El Código Alterno no puede tener más de 4 caracteres.'
      },
      description: {
        required: 'El campo Descripción es obligatorio.',
        maxlength: 'La Descripción no puede tener más de 50 caracteres.'
      },
      bussinessDocumentsDianTypeId: {
        required: 'Debe seleccionar un Tipo DIAN.',
        min: 'Debe seleccionar un Tipo DIAN válido.'
      },
      cxcInvoiceConcept: {
        maxlength: 'El Concepto de Factura CxC no puede tener más de 10 caracteres.'
      },
      cxcCreditNoteConcept: {
        maxlength: 'El Concepto de Nota Crédito CxC no puede tener más de 10 caracteres.'
      },
      cxcDebitNoteConcept: {
        maxlength: 'El Concepto de Nota Débito CxC no puede tener más de 10 caracteres.'
      },
      active: {
        required: 'Debe indicar si el registro está activo.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formBussinessDocumentsType.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  resetContract(bussinessDocumentsClassId: number, branchId: number, enterpriseId: number) {
    this.bussinessDocumentsTypeId = 0;
    this.bussinessDocumentsTypeContract = new BussinessDocumentsTypeModel();
    this.bussinessDocumentsTypeContract.branchId = branchId;
    this.bussinessDocumentsTypeContract.enterpriseId = enterpriseId;
    this.bussinessDocumentsTypeContract.bussinessDocumentsClassId = bussinessDocumentsClassId;
    this.validateForm(this.bussinessDocumentsTypeContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  updateFormState() {
    if (this.bussinessDocumentsTypeContract.active) {
      this.disabledForm = false;
      this.titleState = 'inactivar';
      this.severityState = 'success';
      this.stateBussinessDocumentsType = 'Activo';
      setTimeout(() => this.formBussinessDocumentsType.enable());
      const controlCode = this.formBussinessDocumentsType.controls['code'];
      setTimeout(() => {
        this.bussinessDocumentsTypeContract.bussinessDocumentsTypeId !== 0 ?
          controlCode.enable() : controlCode.disable();
      });
    } else {
      this.disabledForm = true;
      this.titleState = 'Activar';
      this.severityState = 'danger';
      this.stateBussinessDocumentsType = 'Inactivo';
      setTimeout(() => {
        this.formBussinessDocumentsType.disable();
        this.formControlStateService.setControlState(
          this.formBussinessDocumentsType,
          ['bussinessDocumentsClassId', 'branchId', 'enterpriseId', 'code'],
          true
        );
      });
    }
    if (!this.permissionUpdatable) {
      this.disabledForm = true;
      setTimeout(() => this.formBussinessDocumentsType.disable());
    }
  }

  validateForm(bussinessDocumentsType: BussinessDocumentsTypeModel) {
    this.formBussinessDocumentsType = this.formBuilder.group({
      bussinessDocumentsClassId: [bussinessDocumentsType.bussinessDocumentsClassId, [Validators.required, Validators.min(1)]],
      branchId: [bussinessDocumentsType.branchId, [Validators.required]],
      enterpriseId: [bussinessDocumentsType.enterpriseId, [Validators.required]],
      code: [bussinessDocumentsType.code],
      alterCode: [bussinessDocumentsType.alterCode, [Validators.maxLength(4)]],
      description: [bussinessDocumentsType.description, [Validators.required, Validators.maxLength(50)]],
      isRental: [bussinessDocumentsType.isRental],
      bussinessDocumentsDianTypeId: [bussinessDocumentsType.bussinessDocumentsDianTypeId, [Validators.required, Validators.min(1)]],
      cxcInvoiceConcept: [bussinessDocumentsType.cxcInvoiceConcept, [Validators.maxLength(10)]],
      cxcCreditNoteConcept: [bussinessDocumentsType.cxcCreditNoteConcept, [Validators.maxLength(10)]],
      cxcDebitNoteConcept: [bussinessDocumentsType.cxcDebitNoteConcept, [Validators.maxLength(10)]],
      active: [bussinessDocumentsType.active, [Validators.required]]
    });
    this.updateFormState();
  }

  validateFormControls() {
    Object.keys(this.formBussinessDocumentsType.controls).forEach((key) => {
      const control = this.formBussinessDocumentsType.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
